import { AttendClientStore } from "@domain/stores/AttendClientStore";
import { ClientStore } from "@domain/stores/ClientStore";
import { MapClientStore } from "@domain/stores/MapClientStore";
import { MapStore } from "@domain/stores/MapStore";
import { ReportStore } from "@domain/stores/ReportStore";
import { ReturnClientStore } from "@domain/stores/ReturnClientStore";
import { RouteStore } from "@domain/stores/RouteStore";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";

type Input = void;

type Output = void;

export class ClearStoresUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly attendiClientStore: AttendClientStore,
    private readonly clientStore: ClientStore,
    private readonly mapStore: MapStore,
    private readonly mapClientStore: MapClientStore,
    private readonly reportStore: ReportStore,
    private readonly returnClientStore: ReturnClientStore,
    private readonly routeStore: RouteStore,
    private readonly userStore: UserStore
  ) {}

  execute() {
    this.attendiClientStore.clear();
    this.clientStore.clear();
    this.mapStore.clear();
    this.mapClientStore.clear();
    this.reportStore.clear();
    this.returnClientStore.clear();
    this.routeStore.clear();
    this.userStore.clear();

    return;
  }
}
